import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: #0F0F0F;
  color: #FFFFFF;
  padding: 60px 0 30px;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

const TopSection = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 60px;
  
  @media (max-width: 1200px) {
    grid-template-columns: 2fr 1fr 1fr 1fr;
  }
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Logo = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 16px;
  
  span {
    color: #2196F3;
  }
`;

const Tagline = styled.p`
  color: #CCC;
  margin-bottom: 24px;
  font-size: 16px;
`;

const CompanyInfo = styled.div`
  
`;

const NavigationColumn = styled.div`
  
`;

const ColumnTitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 24px;
  color: #FFFFFF;
`;

const NavLinks = styled.ul`
  list-style: none;
  padding: 0;
  
  li {
    margin-bottom: 12px;
  }
`;

const StyledLink = styled(Link)`
  color: #CCC;
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: #2196F3;
  }
`;

const ContactInfo = styled.div`
  margin-top: 16px;
  
  p {
    margin-bottom: 8px;
    color: #CCC;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  
  a {
    color: #FFF;
    font-size: 20px;
    transition: color 0.3s ease;
    
    &:hover {
      color: #2196F3;
    }
  }
`;

const BottomSection = styled.div`
  border-top: 1px solid #333;
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: #999;
  font-size: 14px;
`;

const BottomLinks = styled.div`
  display: flex;
  gap: 24px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
  
  a {
    color: #999;
    font-size: 14px;
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: #2196F3;
    }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Content>
        <TopSection>
          <CompanyInfo>
            <Logo>Car<span>Consul</span></Logo>
            <Tagline>Your independent AI car advisor</Tagline>
            <ContactInfo>
              <p>Email: nick@carconsul.com</p>
            </ContactInfo>
            <SocialIcons>
              <a href="https://twitter.com/carconsul" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://facebook.com/carconsul" aria-label="Facebook">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://instagram.com/carconsul" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://linkedin.com/company/carconsul" aria-label="LinkedIn">
                <i className="fab fa-linkedin"></i>
              </a>
            </SocialIcons>
          </CompanyInfo>
          
          <NavigationColumn>
            <ColumnTitle>Product</ColumnTitle>
            <NavLinks>
              <li><StyledLink to="/features">Features</StyledLink></li>
              <li><StyledLink to="/pricing">Pricing</StyledLink></li>
              <li><StyledLink to="/testimonials">Testimonials</StyledLink></li>
              <li><StyledLink to="/faqs">FAQs</StyledLink></li>
            </NavLinks>
          </NavigationColumn>
          
          <NavigationColumn>
            <ColumnTitle>Company</ColumnTitle>
            <NavLinks>
              <li><StyledLink to="/about">About Us</StyledLink></li>
              <li><StyledLink to="/careers">Careers</StyledLink></li>
              <li><StyledLink to="/contact">Contact</StyledLink></li>
              <li><StyledLink to="/blog">Blog</StyledLink></li>
            </NavLinks>
          </NavigationColumn>
          
          <NavigationColumn>
            <ColumnTitle>Resources</ColumnTitle>
            <NavLinks>
              <li><StyledLink to="/guides">Car Buying Guides</StyledLink></li>
              <li><StyledLink to="/tips">Negotiation Tips</StyledLink></li>
              <li><StyledLink to="/support">Support Center</StyledLink></li>
              <li><StyledLink to="/partners">Partners</StyledLink></li>
            </NavLinks>
          </NavigationColumn>
          
          <NavigationColumn>
            <ColumnTitle>Legal</ColumnTitle>
            <NavLinks>
              <li><StyledLink to="/terms-of-service">Terms of Service</StyledLink></li>
              <li><StyledLink to="/privacy-policy">Privacy Policy</StyledLink></li>
              <li><StyledLink to="/cookies">Cookie Policy</StyledLink></li>
              <li><StyledLink to="/security">Security</StyledLink></li>
            </NavLinks>
          </NavigationColumn>
        </TopSection>
        
        <BottomSection>
          <Copyright>© 2025 CarConsul. All rights reserved.</Copyright>
          <BottomLinks>
            <StyledLink to="/terms-of-service">Terms of Service</StyledLink>
            <StyledLink to="/privacy-policy">Privacy Policy</StyledLink>
            <StyledLink to="/cookies">Cookie Policy</StyledLink>
          </BottomLinks>
        </BottomSection>
      </Content>
    </FooterContainer>
  );
};

export default Footer;
